import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { userRoles } from 'utils/currentUserRoles';

// Dashboard
import Dashboard from 'feature/inventory-management/dashboard/Dashboard';
import MainDashboard from 'feature/inventory-management/Dashboard';

// PTOs
import SearchPtos from 'feature/inventory-management/product-transfer-order/search/Search.connector';
import OpenPtos from 'feature/inventory-management/product-transfer-order/open/Open.connector';

// Reconsignments
import Reconsignments from 'feature/inventory-management/reconsignments/Reconsignments';
import CreateConnector from 'feature/inventory-management/reconsignments/create/CreateConnector';
import Setup from 'feature/inventory-management/reconsignments/create/setup/Setup';

import { useGetAffiliateOptions, useRedirectAffiliateForRole } from 'hooks';
import CreateReconsignmentsWizard from 'feature/inventory-management/reconsignments/create/OneToManyWizard/CreateReconsignmentsWizard';

const ProductOwnershipRoutes = () => {
  useRedirectAffiliateForRole(useGetAffiliateOptions([userRoles.INVENTORY_OWNER]));

  return (
    <>
      <Routes>
        <Route element={<Navigate replace to="dashboard" />} index />
        <Route element={<MainDashboard />} path="dashboard" />
        <Route path="inventory-dashboard">
          <Route element={<Navigate replace to="projections" />} index />
          <Route element={<Dashboard />} path=":view" />
        </Route>
        <Route path="product-ownership">
          <Route element={<OpenPtos />} index path="open" />
          <Route element={<SearchPtos />} path="search" />
        </Route>
        <Route path="reconsignments">
          <Route element={<Reconsignments />} index />
          <Route element={<CreateConnector />} path="create">
            <Route element={<Setup bulk />} index path="bulk-setup" />
            <Route element={<CreateReconsignmentsWizard />} index path="reconsignments" />
          </Route>
        </Route>
      </Routes>
    </>
  );
};

export default ProductOwnershipRoutes;
